import styled from 'styled-components/native'
import Collapsible from 'react-native-collapsible'

export const CollapsibleContainer = styled.View`
  border-radius: ${({ theme }) => theme.metrics.borderRadius.small}px;
  display: flex;
  flex-shrink: 3;
  flex-grow: 0;
  width: 100%;
  ${({ theme }) => theme.shadows.soft};
  background-color: ${({ theme }) => theme.colors.clientCardBg};
`

export const CollapsibleHeader = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
`

/* A note display: none / flex
  To avoid tab navigating INSIDE the collapsible content when COLLAPSED,
  The easiest way is to not display the children when collapsed
*/
export const CollapsibleContent = styled(Collapsible)<{ collapsed: boolean }>`
  display: ${({ collapsed }) => (collapsed ? 'none' : 'flex')};
  padding-left: ${({ theme }) => theme.metrics.baseMargin}px;
  padding-right: ${({ theme }) => theme.metrics.baseMargin}px;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`
